import { Component, Input } from '@angular/core'
import {
  MbCheckoutBaseFormPartialComponent
} from '../mb-checkout-base-form-partial/mb-checkout-base-form-partial.component'

@Component({
  selector: 'mb-checkout-zip-code-form-partial',
  templateUrl: './mb-checkout-zip-code-form-partial.component.html'
})
export class MbCheckoutZipCodeFormPartialComponent extends MbCheckoutBaseFormPartialComponent {

  @Input() zipCodeLabelKey = 'address.zipCode'
}
